import React from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'sonner';

// OrderConfirmationScreen (modal 'Pedido Realizado!' via portal) do cardápio público.
// Extraído VERBATIM de PublicMenu.js (Fase 2 refactor). Renderizado como
// <OrderConfirmationScreen .../>, recebe estado/handlers do pai via props.
const OrderConfirmationScreen = ({ showOrderConfirmation, confirmationOrderData, setShowOrderConfirmation, setConfirmationOrderData, setIsSubmittingOrder }) => {
    if (!showOrderConfirmation || !confirmationOrderData) return null;
    
    const { orderNumber, total, whatsappMessage, restaurantPhone, restaurantName } = confirmationOrderData;
    
    const handleSendWhatsApp = () => {
      if (!restaurantPhone) {
        toast.error('O restaurante ainda não configurou o WhatsApp');
        return;
      }
      
      // Limpar número e criar URL
      const cleanPhone = restaurantPhone.replace(/\D/g, '');
      const encodedMessage = encodeURIComponent(whatsappMessage);
      const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
      
      // Usar location.href - funciona igual em iOS e Android
      window.location.href = whatsappUrl;
    };
    
    const handleClose = () => {
      setShowOrderConfirmation(false);
      setConfirmationOrderData(null);
      setIsSubmittingOrder(false);
    };
    
    return ReactDOM.createPortal(
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden animate-slide-up">
          {/* Conteúdo principal */}
          <div className="p-8 text-center">
            {/* Ícone de sucesso animado */}
            <div className="mb-6">
              <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center">
                <svg 
                  className="w-10 h-10 text-green-500" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={3} 
                    d="M5 13l4 4L19 7" 
                  />
                </svg>
              </div>
            </div>
            
            {/* Mensagem de sucesso */}
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Pedido Realizado!
            </h2>
            
            <p className="text-gray-500 mb-1">
              Pedido <span className="font-semibold text-gray-700">#{orderNumber}</span>
            </p>
            
            <p className="text-2xl font-bold text-green-600 mb-4">
              R$ {total.toFixed(2)}
            </p>
            
            {/* Agradecimento */}
            <p className="text-gray-600 text-lg mb-6">
              Muito obrigado <span className="text-red-500">♥️</span>
            </p>
            
            {/* Botão WhatsApp */}
            {restaurantPhone ? (
              <button
                onClick={handleSendWhatsApp}
                className="w-full py-4 px-6 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-2xl transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Enviar pelo WhatsApp
              </button>
            ) : (
              <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4">
                <p className="text-yellow-700 text-sm">
                  ⚠️ Este restaurante ainda não configurou o WhatsApp.
                </p>
                <p className="text-yellow-600 text-xs mt-1">
                  Seu pedido foi registrado! Aguarde o contato da loja.
                </p>
              </div>
            )}
          </div>
          
          {/* Botão fechar */}
          <div className="px-8 pb-6">
            <button
              onClick={handleClose}
              className="w-full py-3 text-gray-500 hover:text-gray-700 font-medium transition"
            >
              Voltar ao cardápio
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
};

export default OrderConfirmationScreen;
